import type { ReactNode } from 'react'
import TileContent from './TileContent/TileContent'
import { TileButton, TileLink } from './styled-components'

interface ActionTileProps {
  id?: string
  icon: ReactNode
  label: string
  href?: string
  onClick?: () => void
  hidden?: boolean
}

const ActionTile = ({ id, icon, label, href, onClick, hidden = false }: ActionTileProps) => {
  if (hidden) return null

  if (href) {
    return (
      <TileLink id={id} href={href} target='_blank' rel='noopener noreferrer'>
        <TileContent icon={icon} label={label} />
      </TileLink>
    )
  }

  return (
    <TileButton id={id} type='button' onClick={onClick}>
      <TileContent icon={icon} label={label} />
    </TileButton>
  )
}

export default ActionTile
